import template from '../../../../views/statistic/partials/link-list.html';

export default class linkList {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                links: '=',
                linkSubscribers: '=',
                settings: '=',
                dispatcherType: '=',
                disabledDispatchers: '=',
                messageType: '='
            },
            template: template,
            controller: ['$scope', '$element', '$attrs', '$state', '$stateParams', '$rootScope', 'Statistics', (scope, element, attr, $state, $stateParams, $rootScope, Statistics) => {

                scope.showLinks = false;
                scope.linkSubscribers = [];

                scope.goToSubscriber = (subscriberId) => {
                    $state.go('subscriber.show', { id: subscriberId });
                };

                scope.toggleLinks = () => {
                    scope.showLinks = ! scope.showLinks;

                    if (! scope.showLinks) {
                        scope.activeLink = null;
                    }
                };

                scope.hasPrevLink = () => {
                    return scope.activeLink.id > 0;
                };

                scope.toggleLinkPage = (next) => {
                    let newId = next ? scope.activeLink.id + 1 : scope.activeLink.id - 1;
                    scope.showLink(scope.links[newId], newId);
                };

                scope.moreToLoad = () => {
                    return scope.pages > scope.settings.currentPage;
                };

                scope.nextPage = () => {
                    scope.settings.currentPage++;
                };

                scope.toExport = () => {
                    if(scope.dispatcherType === 'automation') {
                        $state.go('statistic.automationexport', {
                            dispatcherType: scope.dispatcherType,
                            id: $stateParams.id,
                            automationId: $stateParams.automationId,
                            statistic: 'link',
                            disabledDispatchers: scope.disabledDispatchers,
                            link: 0,
                            messageType: scope.messageType ? scope.messageType : 'email',
                            startDate: moment(scope.settings.startDate).format('YYYY-MM-DD'),
                            endDate: moment(scope.settings.endDate).format('YYYY-MM-DD')
                        });
                    } else {
                        $state.go('statistic.export', {
                            dispatcherType: scope.dispatcherType,
                            id: $stateParams.id,
                            statistic: 'link',
                            disabledDispatchers: scope.disabledDispatchers,
                            link: 0,
                            messageType: scope.messageType ? scope.messageType : 'email',
                            startDate: moment(scope.settings.startDate).format('YYYY-MM-DD'),
                            endDate: moment(scope.settings.endDate).format('YYYY-MM-DD')
                        });
                    }
                };

                function handleSubscriberResponse(response) {
                    angular.forEach(response.subscribers, function(subscriber) {
                        scope.linkSubscribers.push(subscriber);
                    });

                    scope.totalSubscribers = response.total;
                    scope.perPage = response.perPage;
                    scope.pages = Math.ceil(scope.totalSubscribers / scope.perPage);
                }

                function fetchSubscribersByLink() {
                    if (scope.dispatcherType !== 'abTest') {
                        Statistics.getSubscribersByLink(
                            $stateParams.id,
                            scope.dispatcherType,
                            scope.activeLink.link,
                            scope.activeLink.link_id,
                            scope.settings
                        ).then((response) => {
                            handleSubscriberResponse(response);
                        });
                    } else {
                        Statistics.abTestSubscribersByLink(
                            $stateParams.id,
                            scope.activeLink.link,
                            scope.activeLink.link_id,
                            scope.settings
                        ).then((response) => {
                            handleSubscriberResponse(response);
                        });
                    }

                }

                scope.$watch('settings.currentPage', (newVal, oldVal) => {
                    if (newVal !== oldVal && newVal > 1) {
                        fetchSubscribersByLink();
                    }
                });

                scope.$watchGroup([
                    'settings.selection',
                    'status',
                    'initialized'
                ], () => {
                    $rootScope.$emit('statistics:updateStatistics');
                });

                scope.showLink = (link, index) => {
                    scope.linkSubscribers = [];
                    scope.settings['currentPage'] = 1;
                    scope.showLinks = true;
                    scope.activeLink = link;
                    scope.activeLink.id = index;

                    fetchSubscribersByLink();
                };
            }]
        }
    }
}



